import '../helpers/plugins';
import Swiper from 'swiper';
import settings from '../helpers/settings';
import commons from '../components/commons';
import * as utils from '../helpers/utils';
import PinColumns from '../components/pin-columns';
import HeightToggler from '../components/height-toggler';

let GB = {
    borderedBlockTogglerCta: document.querySelector('.top-section__bordered-block-read-more a'),
    borderedBlockToggler: document.querySelector('.top-section__bordered-block-items-toggler'),

    slideItems: 0,
    swiperEdito: null,

    salesRecordsContainer: document.querySelector('.sales-records__items-container'),
    salesRecordsItems: document.querySelectorAll('.sales-records__item'),
    aboutItems: document.querySelectorAll('.about-items'),
    allDescriptionPopins: document.querySelector('.description-popin'),
    otherPeopleSections: document.querySelectorAll('.other-people'),
    otherPeopleSectionsLength: null,
    otherPeopleSectionsHaveClickEvent: null
};

let PageEditoAboutUs = {
    pinColumns: null,
    rightCol: null,
    leftCol: null,

    init: function () {
        _.bindAll(this, 'windowResize', 'windowLoad'); //'windowScroll' not used
        // debugger;
        let windowResize = _.debounce(this.windowResize, 600);
        // let windowScroll = _.throttle(this.windowScroll, 100);

        settings.get('$win').on('load', this.windowLoad);
        settings.get('$win').on('resize', windowResize);
        // settings.get('$win').on('scroll', windowScroll);

       this.heightToggler = new HeightToggler();
        GB.otherPeopleSectionsLength = GB.otherPeopleSections.length;

        GB.slideItems = $('#swiper-about-us .swiper-slide').length;
        this.swiperInit();

        if (!settings.get('isTabletPortrait') && !settings.get('isMobile')) {
            this.updatePinColumns();
        }

        if (GB.borderedBlockTogglerCta) {

            GB.borderedBlockTogglerCta.addEventListener('click', function(e) {
                e.preventDefault();

                let currentTarget = e.currentTarget;

                currentTarget.parentNode.style.display = 'none';

                GB.borderedBlockToggler.classList.add('toggler-open');

                //Other system: toggler with text change "open / close"
                // if (GB.borderedBlockToggler.classList.contains('toggler-open')) {
                //     GB.borderedBlockToggler.classList.remove('toggler-open');
                //     currentTarget.textContent = currentTarget.dataset.txtopen;
                // } else {
                //     GB.borderedBlockToggler.classList.add('toggler-open');
                //     currentTarget.textContent = currentTarget.dataset.txtclose;
                // }
            });
        }

    },

    updatePinColumns: function() {
        if (GB.pinColumns) {
            GB.pinColumns[settings.get('isTabletPortrait') || settings.get('isMobile') ? 'desactivate' : 'activate']();
        } else {
            this.pinColumnsInit();
        }
    },

    pinColumnsInit: function () {
        if (!settings.get('isTabletPortrait') && !settings.get('isMobile')) {
            GB.pinColumns = new PinColumns({
                triggerSelector: '#parallax-edito-wrapper',
                pinSelector: '.pin-element',
                columnsSelector: '.parallax-item-inner',
                useColumns: true,
                offset: -130
            });
            GB.pinColumns.init();
        }
    },

    addAccordionEvent: function() {
        for (let i = 0; i < GB.otherPeopleSectionsLength; i++) {
            GB.otherPeopleSections[i].addEventListener('click', this.productAccordionHandler, false);
        }
    },

    removeAccordionEvent: function() {
        for (let i = 0; i < GB.otherPeopleSectionsLength; i++) {
            GB.otherPeopleSections[i].removeEventListener('click', this.productAccordionHandler, false);
        }
    },

    productAccordionHandler: function(e) {
        //Putting all parameters needed by the toggleAccordions method inside an object for clarity
        let params = {
            heightToggler: PageEditoAboutUs.heightToggler,
            titleClass: 'h2-title',
            itemClass: 'other-people',
            openItemClass: 'other-people--open'
        };

        commons.toggleAccordions(e, params);
    },

    swiperInit: function() {
        let swiperEditoBreakpoints = {},
        $swiperEdito = $('#swiper-about-us');

        let onSlideReady = function(e, item){
            // Add a class swiper--ready to show slider only when everything is ready
            $(item.container).addClass('swiper--ready');
        };

        if (GB.swiperEdito !== null) {
            GB.swiperEdito.destroy(true, true);
            GB.swiperEdito = null;
        }

        if (GB.slideItems === 1) {
            $swiperEdito.addClass('swiper--1-item');
        } else if (GB.slideItems === 2) {
            $swiperEdito.addClass('swiper--2-items');
        }

        if (((settings.get('isDesktop') || settings.get('isTabletLandscape')) && GB.slideItems <= 3) 
            || (settings.get('isTabletPortrait') && GB.slideItems <= 2) 
            || (settings.get('isMobile') && GB.slideItems <= 1)) {
            $swiperEdito.addClass('no-swiper');
        } else {
            $swiperEdito.removeClass('no-swiper');

            // Need To pass breakpoint dynamically.
            
            // when screen width > 800px and width < 1141px
            swiperEditoBreakpoints[settings.get('breakpoints').tabletLandscape] = {
                slidesPerView: 3,
                spaceBetween: 100,
                autoHeight: false, //was true
                setWrapperSize: false,
                prevButton: null,
                nextButton: null,
                loop: true
            };

            //when screen width > 736px and width < 801px
            swiperEditoBreakpoints[settings.get('breakpoints').tabletPortrait] = {
                slidesPerView: 'auto',
                spaceBetween: 100,
                autoHeight: false, //was true 
                setWrapperSize: false,
                prevButton: null,
                nextButton: null,
                loop: true
            };

            //when screen width < 737px
            swiperEditoBreakpoints[settings.get('breakpoints').mobile] = {
                slidesPerView: 'auto',
                spaceBetween: 25,
                autoHeight: false, //was true
                setWrapperSize: false,
                prevButton: null,
                nextButton: null,
                loop: true
            };

            //when screen width > 1140px
            GB.swiperEdito = new Swiper('#swiper-about-us', {
                speed: 400,
                spaceBetween: 120,
                slidesPerView: 4,
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next',
                preloadImages: false,
                lazyLoading: true,
                lazyLoadingInPrevNext: true,
                lazyLoadingInPrevNextAmount: true,
                lazyLoadingOnTransitionStart: true,
                autoHeight: false, //was true
                setWrapperSize: false,
                loop: true,
                onInit: _.bind(onSlideReady, this, GB.swiperEdito),
                breakpoints: swiperEditoBreakpoints
            });

        }
    },

    windowLoad: function () {
        // console.log('Inside windowLoad');
        if (settings.get('windowSize').width < 737) {
            this.addAccordionEvent();
            GB.otherPeopleSectionsHaveClickEvent = true;
        } else {
            GB.otherPeopleSectionsHaveClickEvent = false;
        }
    },

    windowResize: function () {
        // console.log('Inside windowResize');
        let self = this;

        this.swiperInit();
        //this.updateParallax();
        this.updatePinColumns();
        
        if (settings.get('windowSize').width < 737) {
            if (!GB.otherPeopleSectionsHaveClickEvent) {
                this.addAccordionEvent();
            }
            
            GB.otherPeopleSectionsHaveClickEvent = true;
        }

        if (settings.get('windowSize').width > 736) {
            if (GB.otherPeopleSectionsHaveClickEvent) {
                this.removeAccordionEvent();
            }

            for (let i = 0; i < GB.otherPeopleSectionsLength; i++) {
                GB.otherPeopleSections[i].classList.remove('other-people--open');
                GB.otherPeopleSections[i].querySelector('.row.smooth').removeAttribute('style');
            }
            
            GB.otherPeopleSectionsHaveClickEvent = false;
        }
    }

};

export default PageEditoAboutUs;



// WEBPACK FOOTER //
// ./src/js/specific/page-edito-about-us.js